import { render, staticRenderFns } from "./SchoolsData.vue?vue&type=template&id=4ed33f5a&scoped=true&"
import script from "./SchoolsData.vue?vue&type=script&lang=js&"
export * from "./SchoolsData.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsData.vue?vue&type=style&index=0&id=4ed33f5a&prod&lang=stylus&scoped=true&"
import style1 from "./SchoolsData.vue?vue&type=style&index=1&id=4ed33f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed33f5a",
  null
  
)

export default component.exports